<template>
  <div class="icon">
    <img :src="logo" :style="imgSize">
  </div>
</template>

<script>
import AppInfo from '../../appInfo/index'
export default {
  computed: {
    imgSize () {
      let size = {
        width: 160 + 'px',
        height: 64 + 'px'
      }
      // special logo.
      if (this.isGenericVersion) {
        size.width = 180 + 'px'
        size.height = 53 + 'px'
      }
      return size
    }
  },
  data () {
    return {
      logo: AppInfo.getAppIcon(),
      isGenericVersion: AppInfo.isGenericVersion()
    }
  }
}
</script>

<style lang="less" scoped>
	.icon {
    width: 100%;
    height: 64px;
    margin-top: 50px;
    img {
      width: 160px;
      height: 64px;
      display: inherit;
      margin: 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// Icon.vue?2f17cd5a